// module startup

const init = () => {
    // determine module to load based off of script tag data attribute
    const searchFormArray = document.querySelectorAll('[data-search-form]'); // on generic pages

    searchFormArray.forEach((e) => {
        e.addEventListener('submit', (b) => {
            b.preventDefault();
            const searchInput = e.querySelector('input[name="s"]');
            const searchValue = searchInput.value;
            if (searchValue.length === 5 && !isNaN(searchValue)) {
                const link = `/wp/wp-admin/admin-ajax.php?action=zipcheck&zip=${searchValue}`;
                fetch(link, {
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                    },
                })
                    .then((res) => res.json()) // parse response as JSON (can be res.text() for plain response)
                    .then((response) => {
                        if (response.errors) {
                            document.location = `/?s=${searchValue}`;
                        } else {
                            const firstIndex =
                                response.data.validateZipCode.cities[0];
                            if (typeof firstIndex !== 'undefined') {
                                // redirect to city
                                document.location = `/${firstIndex.state}/${firstIndex.city}?zip=${searchValue}`;
                            } else {
                                document.location = `/?s=${searchValue}`;
                            }
                        }
                    })
                    .catch((err) => {
                        console.log('Error: ', err);
                    });
            } else {
                // normal search
                document.location = `/?s=${searchValue}`;
            }
        });
    });
};

export { init };
